// API URL configuration that works in both preview and deployment
// In preview: frontend runs on :3000, backend on :8001, accessed via preview URL
// In deployment: both run on same domain, /api/* is routed to backend automatically

const getApiUrl = () => {
  // If REACT_APP_BACKEND_URL is explicitly set, use it
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // In development/preview on localhost, we need the full URL
  // In deployment (not localhost), use empty string for relative URLs
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // If we're on localhost or preview environment, use the preview URL pattern
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // For local development, assume backend is on port 8001
      return `http://${hostname}:8001`;
    }
    
    // Check if we're in preview mode (URL contains 'preview')
    if (window.location.href.includes('.preview.')) {
      // Extract the preview URL base and use it
      // The backend should be accessible on the same URL
      return window.location.origin;
    }
  }
  
  // For deployment, use empty string (relative URLs)
  return '';
};

export const API_URL = getApiUrl();
